import { render, staticRenderFns } from "./VCardProTestResult1.vue?vue&type=template&id=69180c08"
import script from "./VCardProTestResult1.vue?vue&type=script&lang=js"
export * from "./VCardProTestResult1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports